module.exports = __webpack_public_path__ + "static/media/picketPluses.f73cf842.jpg";